import { useEffect } from 'react'

import { shallow } from 'zustand/shallow'

import { callApiNew } from 'api/axios'
import { PATHS } from 'api/paths'
import { useArticleStore } from 'state/article'

const useLatestTotalComment = () => {
  const { currentArticle, setTotalComment } = useArticleStore(
    (state) => ({
      currentArticle: state.currentArticle,
      setTotalComment: state.setTotalComment,
    }),
    shallow,
  )

  useEffect(() => {
    let ignore = false
    ;(async () => {
      if (!currentArticle?.id) return

      const res = await callApiNew(
        PATHS.TOGETHER.GET_TOGETHER_POST_LIST,
        {
          params: {
            articleId: String(currentArticle.id),
            sortBy: 'newest',
          },
        },
        'together',
      )
      if (ignore) return
      setTotalComment(res?.data?.pagination?.total_items || 0)
    })()
    return () => {
      ignore = true
    }
  }, [currentArticle?.id, setTotalComment])
}

export default useLatestTotalComment
